<ng-content select="stby-error, [stby-error]" />

@for (error of errors(); track error) {
    <stby-error>{{ error | translate }}</stby-error>
}
